import { create, StoreApi, UseBoundStore } from 'zustand'

interface WebPushNotificationSubscriptionStoreState {
  isChangingSubscription: boolean
  isPermissionForPrompt: boolean
  isPermissionGranted: boolean
  hasSubscription: boolean
}

interface PermissionState {
  isPermissionForPrompt: boolean
  isPermissionGranted: boolean
}

interface WebPushNotificationSubscriptionStoreActions {
  setIsChangingSubscription: (_isChangingSubscription: boolean) => void
  setPermissionState: (_permissionState: PermissionState) => void
  setHasSubscription: (_hasSubscription: boolean) => void
  reset: () => void
}

type WebPushNotificationSubscriptionStore = WebPushNotificationSubscriptionStoreState &
  WebPushNotificationSubscriptionStoreActions

const initialState: WebPushNotificationSubscriptionStoreState = {
  isChangingSubscription: true,
  isPermissionForPrompt: true,
  isPermissionGranted: false,
  hasSubscription: false,
}

const useWebPushNotificationSubscriptionStore: UseBoundStore<StoreApi<WebPushNotificationSubscriptionStore>> = create(
  (set) => ({
    ...initialState,

    setIsChangingSubscription: (newIsChangingSubscription: boolean) => {
      set((state) => ({
        ...state,
        isChangingSubscription: newIsChangingSubscription,
      }))
    },

    setPermissionState: (newPermissionState: PermissionState) => {
      set((state) => ({
        ...state,
        ...newPermissionState,
      }))
    },

    setHasSubscription: (newHasSubscription: boolean) => {
      set((state) => ({
        ...state,
        hasSubscription: newHasSubscription,
      }))
    },

    reset: () => {
      set(initialState)
    },
  }),
)

export { useWebPushNotificationSubscriptionStore }
